import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import React, { useState } from 'react';
import { useTranslation,Trans  } from 'react-i18next';
const Redevelopment = () => {
     const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState({ first: 0 });

    // Function to set the active box
    const handleMouseEnter = (tabKey, index) => {
        setActiveIndex((prev) => ({ ...prev, [tabKey]: index }));
    };

    const boxesData = {
        first: [
            {
                title: t('methodologyTitle1'),
                description: t('methodologyDesc1'),
                imgSrc: "/images/about/methdology/icon/1.svg"
            },
            {
                title: t('methodologyTitle2'),
                description: t('methodologyDesc2'),
                imgSrc: "/images/about/methdology/icon/2.svg"
            },
            {
                title: t('methodologyTitle3'),
                description: t('methodologyDesc3'),
                imgSrc: "/images/about/methdology/icon/3.svg"
            }
        ],
    };

    return (
        <section className="lyt-section typ-redevelopment-section typ-about-redevelopment-section  typ-pb-0" id='ourm'>
            <div className="container">
                <div className="heading-wrapper">
                    <div>
                        <h2 className="bs-heading typdblue mb-2" data-aos="fade-in" data-aos-delay="200">
                            {t('methodologyTitle')}
                        </h2>
                        <p className="bs-para typgrey" data-aos="fade-in" data-aos-delay="300">
                          {t('methodologySubTitle')}
                        </p>
                    </div>
                </div>
                <div className="bs-tab typ-about-red-tabs">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <div className="row typ-align-end">
                            {/* Left Panel */}
                            <div className="col-lg-6 col-md-6 col-12 pe-lg-0 p-md-0">
                                <Tab.Content className="left-panel">
                                    {Object.keys(boxesData).map((tabKey) => (
                                        <Tab.Pane eventKey={tabKey} key={tabKey}>
                                            {boxesData[tabKey].map((box, index) => (
                                                <div
                                                    key={index}
                                                    className={`box ${activeIndex[tabKey] === index ? "active" : ""}`}
                                                    onMouseEnter={() => handleMouseEnter(tabKey, index)}
                                                >
                                                    <div className="box-img">
                                                        <img
                                                            className="img-fluid img"
                                                            src={box.imgSrc}
                                                            alt="icon"
                                                            width={60}
                                                            height={60}
                                                        />
                                                    </div>
                                                    <div className="box-content">
                                                        <div className="title" data-aos="fade-in" data-aos-delay="200">{box.title}</div>
                                                        <div className="description" data-aos="fade-in" data-aos-delay="300">{box.description}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Tab.Pane>
                                    ))}
                                </Tab.Content>
                            </div>

                            {/* Right Panel */}
                            <div className="col-lg-6 col-md-6 col-12 ps-lg-0 ps-md-0">
                                <Tab.Content className="right-panel">
                                    <Tab.Pane eventKey="first">
                                        <div className="imgBox">
                                            <img
                                                className="img-fluid"
                                                src="/images/home/redevelopment/1.jpg"
                                                alt="main"
                                                width={612}
                                                height={681}
                                            />
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </Tab.Container>
                </div>
            </div>
        </section>
    );
};

export default Redevelopment;
